import { makeStyles } from "tss-react/mui";

export const HeaderStyles = makeStyles()({
    header: {
        backgroundColor: "#fff !important",
        height: "60px",
        justifyContent: "center",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
        "& .MuiContainer-root": {
            maxWidth: "1880px !important",
            padding: "0px 40px",
            "@media (max-width: 650px)": {
                padding: "0px 20px",
            },
        },
        "@media (max-width: 650px)": {
            padding: "0px",
        },
    },
    heading: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#0E0E23",
    },
    envBox: {
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "15px",
        border: "1px solid #3B78CE",
        color: "#3B78CE",
        marginLeft: "15px",
        fontSize: "15px",
        fontWeight: "600",
        padding: "10px",
        cursor: "pointer",
    },
    HamburgerMenu: {
        width: "50px",
        display: "flex",
        "@media (max-width: 730px)": {
            display: "flex",
        },
        "@media (min-width: 730px)": {
            display: "none",
        },
    },
    headerRightBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mrginLeft: "15px",
        position: "absolute",
        right: "36px",
    },
    timeZoneBox: {
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        borderRadius: "20px",
        padding: "10px",
        fontSize: "14px"
    },
    headerMainContainer: {
        justifyContent: "flex-start",
        alignItems: "center",
    },
    toolBarCtn:{
        height: "100%",
        paddingInline:'0 !important',
        marginInline:'24px !important',
        borderBottom: '0.5px solid #DEDEDE',
        '@media (max-width: 650px)':{
            marginInline:'20px'
        }
    },
    breadCrumbsTextStyles:{
        textDecoration: 'none',
        cursor: 'pointer'
    }
});